import { useParams, useSearchParams } from "react-router-dom";
import EntityDetailView from "@/components/entity/EntityDetailView";

export default function EntityViewSinglePage() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const entityName = params.entityName as string;
  const entityId = parseInt(params.id as string);
  const initialTab = searchParams.get("tab") || undefined;

  return (
    <EntityDetailView
      entityName={entityName}
      entityId={entityId}
      initialTab={initialTab}
      isPage={true}
    />
  );
}
